var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigationWrap"},[(_vm.isAuthenticated && !_vm.hideFeatures)?_c('Menu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }